import styled, { css } from 'styled-components';
import { token, spaceMixin } from '@zillow/constellation';

export const StyledTourCardEditableControls = styled.div`
    position: relative;
    flex: 1;
`;

export const StyledTourCardEditableControlsDropdown = styled.div`
    display: none;
    position: absolute;
    box-shadow: 0 0 7px -2px rgba(0, 0, 0, 0), 0 0 3px 0 rgba(0, 0, 0, 0.26);
    z-index: 1000;
`;

export const StyledTourCardEditableControlsDropdownElement = styled.a`
    padding: ${spaceMixin('sm')};
    background-color: ${token('colors.white')};
    text-decoration: none;
    display: block;

    &:hover {
        background-color: ${token('colors.gray200')};
        color: ${token('colors.blue400')};
    }
`;

export const StyledTourCardEditableControlsContainer = styled.div`
    position: absolute;
    bottom: -${spaceMixin('xs')};
    right: -${spaceMixin('xs')};
    padding: ${spaceMixin('xs')} ${spaceMixin('xs')} 0 ${spaceMixin('xs')};
    display: inline-block;
    cursor: pointer;

    ${props => props.size === 'md' && css`
        padding: ${spaceMixin('sm')} ${spaceMixin('sm')} ${spaceMixin('xs')} ${spaceMixin('sm')};
        bottom: -${spaceMixin('sm')};
        right: -${spaceMixin('sm')};
    `}

    &:hover {
        ${StyledTourCardEditableControlsDropdown} {
            display: block;
        }
    }
`;
